import React from 'react'
import { connect } from 'react-redux';
import { Divider, Loader } from 'rsuite';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import * as actionsPolicy  from '../../../../app/actions/policy';
import InsCompLogos from '../svg/insCompLogos';
import {insCompBgNames} from '../../../../app/common/types/insCompTypes';

const useStyles = makeStyles((theme) => ({
    custom: {
        backgroundColor: '#f7f7fa',
        color: '#2e94f3',
        letterSpacing: '.15em',
    },
    customArrow: {
        color: '#f7f7fa',
    },
  }));

const OfferCard = ({onForward, totalAmountEUR, insCompany, installments, totalAmountLEVA, msgCode, setSelectedOffer, title, vechicle}) => {
    let price            = null,
        priceLEVA        = null,
        installmentsShow = null;

    const classes = useStyles();

    installments = installments ? installments : [];

    if(installments.length) {
        price = installments.reduce((acc, installment) => (acc + installment), 0 );
        price = Number.parseFloat(price).toFixed(2) ;

        priceLEVA = Number.parseFloat(totalAmountLEVA).toFixed(2) ;

        price = `${price} € / ${priceLEVA} лв.` ;

        
        if(installments.length > 1) {
            installmentsShow = installments.map(installment =>  Number.parseFloat(installment).toFixed(2) );
            installmentsShow = installmentsShow.join(' + ') + ' =';
        }
    }

    const CompanyLogo   = InsCompLogos[insCompany] ? InsCompLogos[insCompany]() : null;
    const insCompNameBg = insCompBgNames[insCompany];

    const updateSelectedOffer = async () => {
        if(!installments.length || !onForward) return;

        setSelectedOffer(insCompany, installments, totalAmountEUR, totalAmountLEVA);

        onForward();
    }
  
    return(
        <Tooltip title={(installments.length && onForward) ? 'Избери' : ''} placement="right" classes={{ tooltip: classes.custom, arrow: classes.customArrow}} arrow>
            <div className="offer-card-container" onClick={updateSelectedOffer} style={(!installments.length || !onForward) ? {cursor: 'unset'} : {}}>
                <div className ="offer-card" >
                    <div className="left-comp">
                        {title && <p style={{padding:" 0 0 .5rem 1rem"}}>{title}</p>}
                        <div style={"ozkins_uniqa_allianz_groupama".includes(insCompany) ? {marginLeft:'1rem'} : "armeetz_bulstrad".includes(insCompany) ? {marginLeft:'-.7rem'} : null}> {CompanyLogo} </div>
                        <h6 className="left-child">{insCompNameBg}</h6>
                        {vechicle && <p style={{padding:" .5rem 0 0 1rem", fontWeight: '600' }}>{vechicle}</p>}
                    </div>
                    { installments.length
                        ? (
                        <div className="right-comp">
                            <h6 className="instalments">{installmentsShow}</h6>
                            <h6 className="price">{price}</h6>
                            <h6 className="year">ЗА 1 ГОДИНА</h6>
                        </div>
                        )
                        : !msgCode
                        ? (
                        <div className="right-comp" style={{padding: '0 1rem .8rem 0'}}>
                            <Loader size="md" speed="slow" />
                        </div>
                        )
                        : (
                        <div className="right-comp" style={{paddingLeft: '1rem'}}>
                            <h6 className="error">{msgCode}</h6>
                        </div>
                        )
                    }
                </div>
                <Divider />
            </div>
        </Tooltip>
    )
}

export default connect(null, actionsPolicy)(OfferCard);
